export default __webpack_public_path__ + "static/media/IFeelSick_07.2a47a8de.png";